import { CAMPAIGN_TYPE } from "../constants";


const campaignsReducer = (state = {
  page: 1,
  page_size: 10,
  items: [],
  listCampaigns: [],
  firstCall: true
}, action) => {
  switch (action.type) {
    case CAMPAIGN_TYPE.FETCHS:
      return {
        ...action.payload,
        firstCall: false
      };
    case CAMPAIGN_TYPE.UPDATE:
      return {
        ...state,
        items: state.items.map((m) => m.id == action.payload.id ? { ...m, ...action.payload } : m)
      }
    case CAMPAIGN_TYPE.ADD_CAMPAIGNS:
      const listCampaigns = action.payload.listCampaigns;
      delete action.payload.listCampaigns;
      return {
        ...state,
        ...action.payload,
        listCampaigns: [...state.listCampaigns, ...listCampaigns]
      }
    default:
      return state;
  }
};

export default campaignsReducer;